export interface RedisBackpressureLatestQueueEnvelope<T> {
  payload: T;
  queuedAt: number;
  retryCount: number;
  revision: string;
}

export interface RedisBackpressureQueueKeys {
  payloadKey: string;
  scheduleKey: string;
  metricsKey: string;
}

export const buildRedisBackpressureQueueKeys = (
  queue: string,
): RedisBackpressureQueueKeys => ({
  payloadKey: `backpressure:${queue}:payloads`,
  scheduleKey: `backpressure:${queue}:schedule`,
  metricsKey: `backpressure:${queue}:metrics`,
});
